<template lang="pug">
v-card(style='max-width: 100%;' :style='{backgroundColor: chatLoader ? "#eee" : ""}')
    v-toolbar.toolbar-settings.text-settings(extended extension-height="24px" style='z-index: 1')
      div(v-if='chatLoader' style='width: 70%; margin-left: 10px')
        v-row
          v-skeleton-loader(#dark style='width: 100%;' type="text@1")
      template(v-else)
        h6(style='display: inline; font-size: 16px;') Id:
        span(v-if="this.$route.path === '/analise-por-servico-entregue'" style='color: white; padding-left: 4px;')
          | {{idConversationAnalysisPerDeliveredService}}
        span(v-else style='color: white; padding-left: 4px;')
          | {{chatInfo._id}}
      v-spacer
      v-btn#closeIcon(icon color='white' @click='closeDialog')
        md-icon close
      template(v-slot:extension)
        div(v-if='chatLoader' style='position: relative; bottom: 10px; width: 30%; margin-left: 10px')
          v-row
            v-skeleton-loader(#dark style='width: 100%;' type="text@1")
        template(v-else)
          div#user-rating(v-if='chatInfo._source.service_evaluation' style='position: relative; bottom: 10px; width: 100%; display: inline;')
            b(style='margin-right: 4px;') {{$t('chatConversation.userRating')}}
            template(v-if='chatInfo._source.service_evaluation')
              v-rating(:value='chatInfo._source.service_evaluation.category1 * 5' size='14' color='#ff9800' dense length='5' readonly style='display: inline;')
            template(v-else)
              | {{$t('chatConversation.noRating')}}
    PerfectScrollbar(v-if='chatLoader')
      v-card-text#loaders(style='padding: 0 32px;')
        v-row(v-for='(message, i) in 5' :key="i" justify='center' align='center')
          v-col(cols='12')
            v-skeleton-loader(
              style='width: 70%; background-color:#EEEEEE'
              :style='{ float: i % 2 != 0  ? "right" : "left" }'
              type="article")
    PerfectScrollbar(v-else)
      v-banner(v-if='showIntents' dark color='rgb(255, 152, 0)' sticky)
        div(style='margin-left: 10px')
          | {{$t('chatConversation.intention')}} {{intent}}
          br
          | {{$t('chatConversation.certain')}} {{score}}%
      v-card-text#scrollContainer(v-if="filterData.length > 0")
        v-row(no-gutters)
          v-col.chatMessage(cols='12' style='text-align: center;')
            span.startChatText
              | {{$t('chatConversation.startOfConversation')}} {{ formatDate(filterData[0]._source.process_time) }}
        v-row(v-for='(message, i) in filterData' :key="i" justify='center' align='center')
          v-col.chatMessage(:id='i == filterData.length - 1 ? "lastMessage" : ""' cols='12')
            v-card(
              v-if="message._source.sender_type !== 'system'"
              flat
              style='width: 70%; padding: 6px 24px;'
              :style='{ float: message._source.sender_type === "user" ? "right" : "left" }'
              @click='showIntentsandScore(message)'
              :class="messageBoxClass(message)")
              v-row.justify-space-between(no-gutters style='margin-top: 8px;')
                div.d-flex
                  template(v-if='message._source.sender_type == "user"')
                    img(:src="localPath.accountCircle" style='border-radius: 50%; height: 36px; width: 36px;')
                  template(v-else-if='message._source.sender_type == "machine"')
                    img(v-if='channelConfig === null' :src="localPath.robot" style='border-radius: 50%; height: 36px; width: 36px;')
                    img(v-else :src="botImage64" style='border-radius: 50%; height: 36px; width: 36px;')
                  //- operator \/
                  template(v-else)
                    img(v-if='channelConfig === null' :src="localPath.accountCircle" style='border-radius: 50%; height: 36px; width: 36px;')
                    img(v-else :src="operatorImage64" style='border-radius: 50%; height: 36px; width: 36px;')
                  v-col(cols='auto' style='align-self: center; padding-left: 8px;')
                    div(style='font-weight: 500;') {{ messageSenderName(message) }}
                div.d-flex.align-center
                  div.d-flex(v-if='message._source.interaction_evaluation')
                    div(v-if='message._source.interaction_evaluation == 1')
                      img(:src="localPath.thumbDown" style='float: right; margin: 3px; height: 24px; width: 24px;')
                      img(:src="localPath.thumbUpColored" style='float: right; height: 24px; width: 24px;')
                    div(v-if='message._source.interaction_evaluation == -1')
                      img(:src="localPath.thumbDownColored" style='float: right; margin: 3px; height: 24px; width: 24px;')
                      img(:src="localPath.thumbUp" style='float: right; height: 24px; width: 24px;')
                  v-tooltip(bottom v-if="message._source.intents && message._source.scores")
                    template(v-slot:activator="{ on, attrs }")
                      v-icon(id="chat-content-icon" v-bind="attrs" v-on="on") mdi-information-outline
                    div(style='display: flex; flex-direction: column;')
                      span(v-if="message._source.intents.IntentName1 && message._source.scores.Conf1") {{message._source.intents.IntentName1}}: {{message._source.scores.Conf1.toFixed(2)}}
                      span(v-if="message._source.intents.IntentName2 && message._source.scores.Conf2") {{message._source.intents.IntentName2}}: {{message._source.scores.Conf2.toFixed(2)}}
                      span(v-if="message._source.intents.IntentName3 && message._source.scores.Conf3") {{message._source.intents.IntentName3}}: {{message._source.scores.Conf3.toFixed(2)}}
              v-card-text(v-html='message._source.isLogicallyDeleted == true ? "Acesso ao anexo expirou" :message._source.event_text')
              v-row(v-if='message._source.sender_type == "machine" && message._source.event_object' no-gutters)
                v-col(v-for='(button, i) in message._source.event_object.buttons' :key='i' cols='12')
                  v-btn#messageBlockButton(depressed block) {{button.title}}
              v-row(no-gutters :style='{float: message._source.sender_type == "user" ? "left" : "right"}')
                v-col(cols='12')
                  span(:class='message._source.sender_type == "user"? "dateUserText" : "dateBotText"')
                    | {{ formatDate(message._source.process_time) }}
                    v-icon(
                            id="chat-content-icon"
                            small
                            right
                            :style='{color: message._source.event_received === true ? "#3b5998" : ""}'
                            ) mdi-checkbox-marked-circle
                    v-icon(
                            id="chat-content-icon"
                            small
                            right
                            :style='{color: message._source.event_received === true ? "#43a047" : ""}'
                            ) mdi-checkbox-marked-circle
            v-row(v-else no-gutters)
              v-col(cols='12' style='text-align: center;')
                span.startChatText
                  | {{message._source.event_text}}

    v-divider
    md-checkbox(v-if='showChatObserver && isDataPrev'
                v-model='chatObserver'
                class="action-checkbox"
                @change='startChatObserver()') Manter o foco em novas mensagens
    v-card-actions(style='padding: 12px 12px 12px 12px;')
      div(v-if='chatLoader' style='width: 30%; margin-left: 10px')
        v-row
          v-skeleton-loader(style='width: 100%; background-color:#EEEEEE' type="text@1")
      div(v-else class='footerId')
        md-button(@click='generateFile("print")' :disabled='loadingGeneration.print' class='md-sm md-facebook' style='float: right; height: 36px;')
          template(v-if='!loadingGeneration.print')
            md-icon(style='font-size: 24px !important;') print
            md-tooltip(md-direction="bottom")
              | {{$t('chatConversation.printOut')}}
          template(v-else)
            v-progress-circular(
              size='20',
              width='2',
              style='transition: 0.1s; height: 33px;'
              color='#fff'
              indeterminate)
        md-button(@click='generateFile("pdf")' :disabled='loadingGeneration.pdf' class='md-sm md-facebook' style='float: right; margin-right: 0px; height: 36px; margin-right: 4px;')
          template(v-if='!loadingGeneration.pdf')
            md-icon(style='font-size: 24px !important;') picture_as_pdf
            md-tooltip(md-direction="bottom")
              | {{$t('chatConversation.exportPdf')}}
          template(v-else)
            v-progress-circular(
              size='20',
              width='2',
              style='transition: 0.1s; height: 33px;'
              color='#fff'
              indeterminate)
      v-spacer
      v-btn(@click='closeDialog' color='#43a047' style='color: white;') OK
</template>

<script>
import { PerfectScrollbar } from 'vue2-perfect-scrollbar'
import 'vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css'
import isTenantMixin from '@/components/mixins/isTenantMixin'
import { mapGetters } from 'vuex'
// import Swal from 'sweetalert2'
import jsPDF from 'jspdf'
import 'jspdf-autotable'
import { selectedLocale } from '@/plugins/i18n'
import moment from 'moment'

export default {
  components: {
    PerfectScrollbar
  },
  props: {
    chatData: {
      type: Object,
      required: true
    },
    chatInfo: {
      type: Object,
      required: true
    },
    chatLoader: {
      type: Boolean,
      default: true
    },
    channelConfig: {
      required: true
    },
    idConversationAnalysisPerDeliveredService: {
      type: String,
      required: false
    },
    showChatObserver: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  mixins: [isTenantMixin],
  computed: {
    ...mapGetters('workspaces', ['active']),
    botImageUrl () {
      if (this.channelConfig) {
        return this.channelConfig.config.botAvatarUrl
      }
      return null
    },
    operatorImageUrl () {
      if (this.channelConfig) {
        return this.channelConfig.config.welcomeImageUrl
      }
      return null
    }
  },
  watch: {
    chatLoader (nV) {
      if (!nV) {
        this.$nextTick(() => {
          this.$el.querySelector('#lastMessage').scrollIntoView()
        })
      }
    },
    chatData: {
      deep: true,
      handler () {
        this.filterData = this.getFilterData()
        this.$nextTick(() => {
          this.$el.querySelector('#lastMessage').scrollIntoView()
        })
      }
    }
  },
  data () {
    return {
      localPath: {
        accountCircle: require('../../public/img/chat-history/account-circle.png'),
        robot: require('../../public/img/chat-history/robot.png'),
        star: require('../../public/img/chat-history/star.png'),
        starOutline: require('../../public/img/chat-history/star-outline.png'),
        thumbUp: require('../../public/img/chat-history/thumb-up.png'),
        thumbUpColored: require('../../public/img/chat-history/thumb-up-colored.png'),
        thumbDown: require('../../public/img/chat-history/thumb-down.png'),
        thumbDownColored: require('../../public/img/chat-history/thumb-down-colored.png')
      },
      loadingGeneration: {
        pdf: false,
        print: false
      },
      botImage64: '',
      operatorImage64: '',
      showIntents: false,
      intent: '',
      score: '',
      filterData: [],
      chatObserver: false,
      interval: undefined
    }
  },
  methods: {
    messageSenderName (message) {
      if (message._source.sender_type === 'user' && !message._source.sender_name) {
        return 'Usuário'
      } else {
        return message._source.sender_name
      }
    },
    messageBoxClass (message) {
      if (message._source.sender_type === 'user') return 'user-message'
      else if (message._source.sender_type === 'operator' && message._source.event_type === 'whisper') return 'operator-whisper-message'
      else return 'operator-bot-message'
    },
    closeDialog () {
      this.showIntents = false
      this.intent = ''
      this.score = ''
      clearInterval(this.interval)
      this.chatObserver = false
      this.$emit('close')
    },
    showIntentsandScore (message) {
      if (message._source.intents && message._source.scores) {
        this.showIntents = true
        this.intent = message._source.intents.IntentName1
        this.score = (message._source.scores.Conf1 * 100).toFixed(1)
      } else {
        this.showIntents = false
        this.intent = ''
        this.score = ''
      }
    },
    getFilterData () {
      let data = this.chatData?.data?.filter((data, index) => {
        let findEqualTextIndex = this.chatData.data.findIndex(item => item?._source?.event_text === data?._source?.event_text)
        let isDifferentMessage = true

        if (findEqualTextIndex !== index) {
          let nextIndex = index + 1
          let previousIndex = index - 1
          let nextItem = this.chatData.data[nextIndex]
          let previousItem = this.chatData.data[previousIndex]
          if ((nextItem?._source?.event_text === data?._source?.event_text) || (previousItem?._source?.event_text === data?._source?.event_text)) {
            isDifferentMessage = false
          }
        }
        return (data?._source?.sender_type !== 'user') || (findEqualTextIndex === index) || isDifferentMessage
      })
      return data
    },
    formatDate (date) {
      return moment(date).locale(selectedLocale).format('L LT')
    },
    leadZeros (pad, number) {
      return String(number).padStart(pad, '0')
    },
    async generateFile (type) {
      this.loadingGeneration[type] = true
      // eslint-disable-next-line
      const doc = new jsPDF()

      doc.setFontSize(18)
      doc.setTextColor(47, 79, 79)
      doc.setFont(undefined, undefined, '700')
      doc.text(15, 20, this.$t('chatConversation.talk'))
      doc.setFont(undefined, undefined, '300')
      doc.text(48, 20, `${this.chatInfo._id}`)

      doc.setFontSize(12)
      doc.setTextColor(119, 136, 153)
      doc.setFont('times', undefined, '700')
      doc.text(15, 28, this.$t('chatConversation.userRating'))
      doc.setFont('times', undefined, '300')

      doc.text(56, 28, `${this.chatInfo._source.service_evaluation ? `${this.chatInfo._source.service_evaluation.category1 * 5} ${this.$t('chatConversation.starts')}` : this.$t('chatConversation.noRating')}`)

      let containerClone = document.querySelector('#scrollContainer').cloneNode(true)
      let checkIcons = containerClone.querySelectorAll('#chat-content-icon')
      checkIcons.forEach(item => item.parentNode.removeChild(item))
      let cardTexts = containerClone.querySelectorAll('.v-card__text')
      cardTexts.forEach(item => {
        item.innerText = item.innerText.replace(/([\u2700-\u27BF]|[\uE000-\uF8FF]|\uD83C[\uDC00-\uDFFF]|\uD83D[\uDC00-\uDFFF]|[\u2011-\u26FF]|\uD83E[\uDD10-\uDDFF])/g, '')
      })
      doc.html(containerClone, {
        html2canvas: {
          scale: 0.25
        },
        y: 35,
        margin: 20,
        width: 210,
        windowWidth: 700,
        callback: (doc) => {
          if (type === 'pdf') {
            let timestamp = Date.now()
            doc.save(`${timestamp}_conversa_${this.chatInfo._id}.pdf`)
          } else if (type === 'print') {
            window.open(doc.output('bloburl'))
          }
        }
      })
      setTimeout(() => {
        this.loadingGeneration[type] = false
      }, 1000)
    },
    toDataURL (url, callback) {
      var xhr = new XMLHttpRequest()
      xhr.onload = function () {
        var reader = new FileReader()
        reader.onloadend = function () {
          callback(reader.result)
        }
        reader.readAsDataURL(xhr.response)
      }
      xhr.open('GET', url)
      xhr.responseType = 'blob'
      xhr.send()
    },
    startChatObserver () {
      if (this.chatObserver) {
        this.interval = setInterval(() => { this.$emit('getChatData') }, 5000)
      } else {
        clearInterval(this.interval)
      }
    }
  },
  mounted () {
    this.filterData = this.getFilterData()
    if (this.channelConfig) {
      this.toDataURL(this.channelConfig.config.botAvatarUrl, (dataURL) => { this.botImage64 = dataURL })
      this.toDataURL(this.channelConfig.config.welcomeImageUrl, (dataURL) => { this.operatorImage64 = dataURL })
    }
  }
}
</script>
<style lang="scss">
.user-message {
  background-color: #00BFA5 !important;
}
.operator-bot-message {
  background-color: #E0E0E0 !important;
}
.operator-whisper-message {
  background-color: #FCE4EC !important
}
.toolbar-settings {
  background: linear-gradient(60deg, #66bb6a, #43a047);
  padding: 0 16px;
}
.text-settings {
  color: white !important;
}
#closeIcon .md-icon.md-theme-default.md-icon-font {
  color: #fff !important;
}
#loaders .v-skeleton-loader__heading.v-skeleton-loader__bone {
  margin-left: 16px !important;
  margin-top: 12px !important;
}
.dateBotText {
  font-size: 12px;
  color: #90A4AE;
}
.dateUserText {
  font-size: 12px;
  color: #00796B;
}
.startChatText {
  font-size: 13px;
  color: #9E9E9E;
  letter-spacing: 1px;
}
.footerId {
  font-size: 16px;
  color: #9E9E9E;
}
#messageBlockButton {
  margin: 8px 0;
  pointer-events: none;
  white-space: normal;
  height: auto;
  padding-top: 8px;
  padding-bottom: 8px;
  min-height: 36px;
}
#messageBlockButton > .v-btn__content {
  width: 100%;
}
#scrollContainer {
  padding-right: 32px;
  padding-left: 32px;
}

.action-checkbox {
  padding-left: 12px;
  height: 25px;

  ::v-deep .v-label {
    margin-left: 5px;
  }
}

</style>
